/**
 * empty call for tricking props
 */
const noop = () => {}

export default noop
